import { SessionType } from 'api';
import { SettingsType } from 'common';
import { AppRootStateType } from 'state/store';

export const sessionsSelect = (state: AppRootStateType): SessionType[] =>
  state.sessions.sessions;
export const sessionsSettingsSelect = (state: AppRootStateType): SettingsType =>
  state.sessions.sessionsSettings;
